export const environment = {
  production: true,
  keycloak_config: {
    url: 'https://beta.keycloak.rgsplus.nl',
    realm: 'RGSplus',
    clientId: 'webapp',
    clientUuid: '176b1023-a37d-4d4f-88a1-6e78fc7bf0e3',
  },
  kibSpringAppUrl: 'https://kib.service.rgsplus.nl',
  springAppUrl: 'https://beta.service.rgsplus.nl',
  googleMapsApiUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
  googleMapsApiKey: 'AIzaSyCVunR7yNdySupZyaxamg-MN7rt5a0EBBY',
  excludeUrls: ['https://maps.googleapis.com/maps/api/geocode/json', '/assets', '/clients/public'],
  webSocketMonitorIntervalSecs: 2.5,
  changelogUrl: 'https://rgsplus.atlassian.net/servicedesk/customer/portal/1/article/187891714',
  aiGenerationUrl: 'https://ai.rgsplus.nl:8000/generate_remark',
  mobileAppUrl: 'https://beta.m.rgsplus.nl',
  primengKey:
    'eyJpZCI6ImQxNTk4YjNjLTAyNzItNDYwNi05MTUzLTExNjU3NTg2MDMxYiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODQ1NDg5NDksImV4cCI6MTgxNjA4NDk0OX0.zEe98r6eN2238TPEME_XCnCOh7dnSRGkNyM2c-lYIV5H10QY-ii9aH0uNUkQ6PASrpoIzEOpIr1EeTDY9jM4Cg',
};
